import React from 'react'

import { useTranslation } from '../../../../../app/_providers/TranslationProvider.client'
import { ProductReviewsContainer } from '../../../../../containers/ProductReviewsContainer'
import { WriteReviewButton } from '../WriteReviewButton'

import { Body, MessageWrapper } from './styles'

export const ProductReviewsEmptyState: React.FC<{
  reviewSubmitted: boolean
  onWriteReview: () => void
}> = ({ reviewSubmitted, onWriteReview }) => {
  const {
    magnolia: {
      reviewsPage: { emptyMessage },
    },
  } = useTranslation()

  const { results, status } = ProductReviewsContainer.useContainer()

  if (
    status === 'resolved' &&
    results !== undefined &&
    results.reviews.length === 0 &&
    results.totalReviews === 0
  )
    return (
      <Body>
        <MessageWrapper>{emptyMessage}</MessageWrapper>
        <WriteReviewButton variant='filled' disabled={reviewSubmitted} onClick={onWriteReview} />
      </Body>
    )

  return null
}
